<!-- Large/card discount display-->
@if (size.toLowerCase() === 'large') {
  <glxy-alert type="info" size="small">
    <strong>Active Discounts</strong>
    <glxy-alert-extended>
      @for (discount of discountsFormatted; track discount) {
        <div>
          {{ discount }}
        </div>
      }
    </glxy-alert-extended>
  </glxy-alert>
}
<!-- Small/table/list discount display-->
@if (size.toLowerCase() === 'regular') {
  <div>
    <strong>Active Discounts</strong>
    <ul>
      @for (discount of discountsFormatted; track discount) {
        <li>{{ discount }}</li>
      }
    </ul>
  </div>
}
